module.exports = __webpack_public_path__ + "components/social-bubble/static/facebook-f288609b8cf2ed80e9fded9fa6ce91e9.svg";